import React from 'react'
import Layout from '../../common/Layout'
import AdministrationResetPasswordContainer from '../../features/AdministrationResetPassword/AdministrationResetPasswordContainer'
import 'bootstrap/dist/css/bootstrap.min.css';

export default {
  path: '/administration/reset-password',
  async action ({ params }) {
    return {
      title: 'Reset Password',
      component: <Layout containerWell><AdministrationResetPasswordContainer /></Layout>
    }
  }

}
